export const getDxAiPatientClinicMuiButton = (palette: any) => ({
  MuiButton: {
    styleOverrides: {
      root: {
        width: "100%",
        height: "40px",
        padding: "12px 6px",
        boxShadow: "none",
        borderRadius: "4px",
      },
      contained: {
        backgroundColor: palette["primary"].main,
        color: palette["on-primary"].main,
        "&:hover": {
          backgroundColor: palette["primary"].main,
          color: palette["on-primary"].main,
        },
        "&:focus": {
          backgroundColor: palette["primary"].main,
          color: palette["on-primary"].main,
        },
        "&.Mui-disabled": {
          backgroundColor: palette.stateLayer.onsurface["opacity-0.12"],
          color: palette.stateLayer.onsurface["opacity-0.16"],
        },
      },
      text: {
        backgroundColor: "transparent",
        color: palette.primary.main,
        "&:hover": {
          backgroundColor: "transparent",
        },
        "&:focus": {
          backgroundColor: "transparent",
        },
        "&.Mui-disabled": {
          color: palette.stateLayer.onsurface["opacity-0.16"],
        },
      },
    },
  },
});
